import { render, staticRenderFns } from "./NRWbauantragSonderbau65.vue?vue&type=template&id=2ccdf16a&"
import script from "./NRWbauantragSonderbau65.vue?vue&type=script&lang=js&"
export * from "./NRWbauantragSonderbau65.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports